import type { StateCreator } from 'zustand';
import type { SliceMutators } from '~/store/mutators';
import type { MatchResult } from '~/types/pipeline';

export type ReferencePointSlice = {
  referencePoint: {
    results: MatchResult[] | null;
  };
  setMatchResults: (rs: MatchResult[] | null) => void;
  resetReferencePoint: () => void;
};

const INITIAL_REFERENCE_POINT = {
  results: null,
} satisfies ReferencePointSlice['referencePoint'];

export function matchResultsEqual(
  a: readonly MatchResult[] | null,
  b: readonly MatchResult[] | null,
): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const aMatch = a[i];
    const bMatch = b[i];
    if (!aMatch || !bMatch) return false;
    if (
      aMatch.frameIndex !== bMatch.frameIndex ||
      aMatch.dx !== bMatch.dx ||
      aMatch.dy !== bMatch.dy ||
      aMatch.confidence !== bMatch.confidence
    ) {
      return false;
    }
  }
  return true;
}

export const createReferencePointSlice: StateCreator<
  ReferencePointSlice,
  SliceMutators,
  [],
  ReferencePointSlice
> = (set) => ({
  referencePoint: { ...INITIAL_REFERENCE_POINT },
  setMatchResults: (rs) =>
    set((s) => {
      if (matchResultsEqual(s.referencePoint.results, rs)) return;
      s.referencePoint.results = rs;
    }),
  resetReferencePoint: () =>
    set((s) => {
      s.referencePoint = { ...INITIAL_REFERENCE_POINT };
    }),
});
